export var FileTypeEnum;
(function (FileTypeEnum) {
    FileTypeEnum["Raw"] = "Raw";
    FileTypeEnum["Pdf"] = "Pdf";
    FileTypeEnum["Thumbnail"] = "Thumbnail";
    FileTypeEnum["Preview"] = "Preview";
    FileTypeEnum["BimPreview"] = "BimPreview";
    FileTypeEnum["BimThumbnail"] = "BimThumbnail";
})(FileTypeEnum || (FileTypeEnum = {}));
//# sourceMappingURL=FileEnum.js.map